import adminEnvConfig from '../config/environment.js';

export const API_BASE_URL = adminEnvConfig.api.baseUrl

export const API_ENDPOINTS = {
  // Authentication
  health: `${API_BASE_URL}/api/health`,
  
  // Hunts
  hunts: `${API_BASE_URL}/api/hunts`,
  huntStats: (id) => `${API_BASE_URL}/api/hunts/${id}/stats`,
  
  // Sessions
  sessions: `${API_BASE_URL}/api/sessions`,
  manualSession: `${API_BASE_URL}/api/sessions/manual`,
  sessionStats: `${API_BASE_URL}/api/sessions/stats/overview`,
  validateCode: `${API_BASE_URL}/api/sessions/validate-code`,
  completeSession: (id) => `${API_BASE_URL}/api/sessions/${id}/complete`,
  deleteSession: (id) => `${API_BASE_URL}/api/sessions/${id}/delete`,
  
  // Webhooks
  webhooks: `${API_BASE_URL}/api/webhooks`,
  webhookHealth: `${API_BASE_URL}/api/webhooks/health`,
  webhookStats: `${API_BASE_URL}/api/webhooks/stats`,
  testWebhook: `${API_BASE_URL}/api/webhooks/test`,
  testEmail: `${API_BASE_URL}/api/webhooks/test-email`,
  
  // Analytics
  analytics: `${API_BASE_URL}/api/analytics`,
  analyticsOverview: (days = 30) => `${API_BASE_URL}/api/analytics/overview?days=${days}`,
  analyticsHuntPerformance: (days = 30) => `${API_BASE_URL}/api/analytics/hunt-performance?days=${days}`,
  analyticsDailyTrends: (days = 30) => `${API_BASE_URL}/api/analytics/daily-trends?days=${days}`,
  analyticsMonthlyTrends: (months = 3) => `${API_BASE_URL}/api/analytics/monthly-trends?months=${months}`,
  analyticsCustomerInsights: (days = 30) => `${API_BASE_URL}/api/analytics/customer-insights?days=${days}`,
  analyticsRevenue: (days = 30) => `${API_BASE_URL}/api/analytics/revenue?days=${days}`,
  analyticsHunts: `${API_BASE_URL}/api/analytics/hunts`,
  analyticsExchangeRates: `${API_BASE_URL}/api/analytics/exchange-rates`,
  
  // Settings
  settings: `${API_BASE_URL}/api/settings`,
  settingsPricing: `${API_BASE_URL}/api/settings/pricing`,
  settingsPriceHistory: `${API_BASE_URL}/api/settings/price-history`,
  settingsEmail: `${API_BASE_URL}/api/settings/email`,
  settingsEmailTest: `${API_BASE_URL}/api/settings/email/test`,
  settingsEmailTemplateTest: `${API_BASE_URL}/api/settings/email/test-template`,

  // Auth
  login: `${API_BASE_URL}/api/auth/login`,
  admins: `${API_BASE_URL}/api/settings/admins`,

  // Booking APIs
  bookingAPIs: () => `${API_BASE_URL}/api/booking-apis`,
  bookingAPIToggle: (id) => `${API_BASE_URL}/api/booking-apis/${id}/toggle`,
}

export const REFRESH_INTERVAL = adminEnvConfig.ui.refreshInterval

export const STATUS_COLORS = {
  active: 'success',
  completed: 'primary',
  expired: 'danger',
  pending: 'warning'
}

export const STATUS_LABELS = {
  active: 'Active',
  completed: 'Completed',
  expired: 'Expired',
  pending: 'Pending'
}
